import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TourService, UI_TOUR_OPTIONS } from 'ngx-ui-tour-core';

/**
 * Wires the ngx-ui-tour engine for an app. `TourService` is not
 * `providedIn: 'root'` and depends on the `UI_TOUR_OPTIONS` token, so apps must
 * register both. Add `provideKirigamiTour()` to the app's bootstrap providers,
 * then mount `<kirigami-tour-step />` once in the app shell.
 */
export function provideKirigamiTour(): EnvironmentProviders {
  return makeEnvironmentProviders([TourService, { provide: UI_TOUR_OPTIONS, useValue: {} }]);
}
